import { useState } from 'react';

export default function TechFilter() {

  const [selected, setSelected] = useState('tools');

  const options = [
    { value: 'tools', label: 'Tools' },
    { value: 'services', label: 'Services' },
    { value: 'chains', label: 'Chains' },
    { value: 'web', label: 'Web' },
    { value: 'mobile-dev', label: 'Mobile Dev' },
    { value: 'devops', label: 'DevOps' },
    { value: 'database', label: 'Database' },
    { value: 'cloud', label: 'Cloud Technologies' },
  ];

  return (
    <div className="tech-filter">
        {options.map((option) => (
          <button
            key={option.value}
            className={`tech-filter-option ${selected === option.value ? 'active' : ''}`}
            onClick={() => setSelected(option.value)}
          >
            {option.label}
          </button>
        ))}
    </div>
  );
};
